<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- LANGUAGE FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_coordination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination')?.value}}</span>
                    </div>

                    <!-- INPUT LANGUAGE -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_language}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedLanguage')?.value?.value}}</span>
                    </div>

                    <!-- INPUT PERIOD -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_period}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedPeriod')?.value?.descrip}}</span>
                    </div>

                    <!-- INPUT MES -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_month}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedMonth')?.value}}</span>
                    </div>

                    <!-- INPUT CURRENCIES -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_currency}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCurrency')?.value?.value}}</span>
                    </div>

                    <!-- INPUT DATE -->
                    <div class="p-formgrid p-grid p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_comments}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <textarea id="commentsModal" formControlName="selectedComments" rows="2" cols="30"
                                pInputTextarea autoResize="autoResize" maxlength="300" #myInput
                                (blur)="updateComments()"></textarea>
                            <label class="nopadding clrlbl">{{myInput.value.length}}/300</label>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>


        <!-- CRUD FORM 
        <div class="p-xl-6 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

             INPUT DATE 
            <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                <div class="subTitle p-col-12 p-md-4">
                    <span>Agregue Comentarios </span>
                </div>
                <div class="p-col-12 p-md-8">
                    <textarea id="commentsModal" formControlName="selectedComments" rows="5" cols="30" pInputTextarea
                        autoResize="autoResize" maxlength="300" #myInput (blur)="updateComments()"></textarea>
                    <label class="nopadding clrlbl">{{myInput.value.length}} / 300 </label>
                </div>
            </div>
        </div> -->

    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL FII -->
        <p-tabPanel [header]="'FII Die'">
            <p-table emptyMessage="Registros no existentes" #dt1 [columns]="colsFII" [value]="dataFII"
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlFII"
                responsive="true" editMode="row" responsive="true" dataKey="id.language">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataFII,colsFiFII,'FII-RECEIVE-PAYABLE')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataFII,colsFiFII,'FII-RECEIVE-PAYABLE')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListFII()"></button>

                            <button pButton pRipple type="button" icon="pi pi-fw pi-arrow-left" label="Devolver a Local"
                                class="p-button-raised p-button-success p-m-2 z-5"
                                (click)="approveSendToNational('REJECT')"
                                *ngIf="buttonMessage?.includes('guive_back_')"></button>

                            <button pButton pRipple type="button" icon="pi pi-fw pi-arrow-right"
                                *ngIf="buttonMessage?.includes('approve_')" [label]="getApproveButtonLabel()"
                                class="p-button-raised p-button-success p-m-2 z-5"
                                (click)="approveSendToNational('APPROVE')"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="text-left">ID</th>
                        <th class="text-left">Descripción</th>
                        <th class="text-left">Tipo</th>
                        <th class="amount">Cantidad ({{globalUserDataForm.get('selectedCurrency')?.value?.valueId}})</th>
                        <th class="amount">Editar</th>

                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pEditableRow]="rowData">
                        <td class="text-left">
                            {{ rowData.concepId ? rowData.concepId : '' }}
                        </td>
                        <td class="text-left" style="white-space: normal; word-wrap: break-word;">
                            <mark [ngStyle]="{ 'background-color': rowData?.itemColor != null ? rowData?.itemColor : 'transparent',
                   'font-weight': rowData?.bold != null && rowData.bold ? 'bold' : 'normal' }">
                                {{ rowData?.descrip ? rowData.descrip : 'S/N' }}
                            </mark>

                        </td>
                       
                        <td class="text-left">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="rowData.conType" maxlength="60">
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ rowData.conType ? rowData.conType : '' }}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td class="amount">
                            {{ isNumeric(rowData.amount) ? (rowData.amount | number: '1.2-2') : rowData.amount }}
                        </td>

                        <td *ngIf="rowData.concepId" class="amount">
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                                (click)="redirectToConceptDetail(rowData)"></button>
                        </td>

                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>

                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataFII != null ? dataFII.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>